import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField, Grid, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import APIService from '../services/APIService';
import Loading from './Loading';
import { BUFFET } from '../constants/RestaurantType';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
});

class WasteItemAdder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: props.open,

            name: '',
            type: '',

            types: [],

            loading: true
        };
    }

    addItem() {
        const { name, type } = this.state;

        const item = {
            name,
            food_type_id: type,
            wasted: null
        };

        this.props.onAddedItem(item);

    }

    componentDidMount() {
        APIService.getFoodTypes()
            .then((types) => {
                types = types.filter((type) => type.type === BUFFET);
                this.setState({
                    types,
                    loading: false
                });
            });
    }

    render() {
        const { classes } = this.props;

        if (this.state.loading) {
            return <Loading/>;
        }

        return (
            <Modal
                open={this.props.open}
                onClose={this.props.onClose}
            >
                <div className={classes.paper}>
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <Typography variant="title">{this.props.t('Lisää ruokalaji')}</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={this.props.t('Ruokalajin nimi')}
                                value={this.state.name}
                                onChange={(event) => this.setState({name: event.target.value})}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                select
                                label={this.props.t('Kategoria')}
                                value={this.state.type}
                                onChange={(event) => this.setState({type: event.target.value})}
                            >
                                {this.state.types.map(type => (
                                    <MenuItem key={type.id} value={type.id}>
                                        {this.props.i18n.language === 'en' ? type.name_en || type.name : type.name}
                                    </MenuItem>
                                ))};
                            </TextField>
                        </Grid>

                        <Grid item xs={12} style={{textAlign: 'right'}}>
                            <Button
                                color="primary"
                                onClick={() => this.addItem()}
                            >
                                {this.props.t('Lisää')}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Modal>
        );
    }
}

WasteItemAdder.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(WasteItemAdder));



// WEBPACK FOOTER //
// ./resources/assets/js/components/WasteItemAdder.js